import PentestPage from './Pentest';

export { PentestPage };
export default PentestPage;
